import { createContext } from "react";

const officeContext = createContext();

export default officeContext;
